<template>
  <div>
    <v-dialog ref="dialog" v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>{{ item.name }}</v-card-title>
        <v-card-text>
          <v-row dense></v-row>
          <div class="d-flex flex-column">
            <span> <strong>Inicio: </strong> {{ formatDate(item.start) }}</span>
            <span><strong>Término</strong> {{ formatDate(item.end) }}</span>
            <span
              ><strong>Link de acesso: </strong
              ><a :href="item.link" target="_blank">{{ item.link }}</a></span
            >
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red darken-1" text @click="late">
            <v-icon>mdi-pencil-outline</v-icon>Modificar aula
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="confirm">
            <v-icon>mdi-check-outline</v-icon>Dar esta aula
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { format } from "date-fns";
export default {
  name: "class-edit-dialog",
  props: {
    item: {
      type: Object,
    },
  },
  data: () => {
    return {
      dialog: false,
      postpone: false,
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    confirm() {
      this.$emit("confirm", this.item);
    },
    formatDate(date) {
      return format(date, "dd/MM/yyyy HH:mm");
    },
    late() {
      this.$emit("adiar", this.item);
    },
  },
};
</script>
<style lang="css"></style>
